import React, { useEffect } from 'react';
import {
  Route,
  Navigate,
  useLocation,
  Routes as RRRoutes,
} from 'react-router-dom';
import {
  WealthOverviewPage,
  LoginPage,
  NetWorthDetailsPage,
  ProspectAssessmentPage,
  ProspectAssessmentIntersititialPage,
  AuthenticatingPage,
  DocumentReviewPage,
  AccountDetailsPage,
  LogoutPage,
} from '../../pages';
import { AuthRoute } from '../../atoms';
import { useConfig, useSession } from '../../../hooks';
import { RouteValues, RouteValue } from '../../../types';

const skipRefreshUrls: RouteValue[] = [
  RouteValues.logout,
  RouteValues.authenticating,
];

const Routes: React.FC = () => {
  const location = useLocation();
  const { environment } = useConfig();
  const { refreshSessionTimer } = useSession();

  useEffect(() => {
    const url = location.pathname.toLowerCase();
    if (!skipRefreshUrls.some((route) => url.includes(route))) {
      refreshSessionTimer();
    }
  }, [location]);

  return (
    <RRRoutes>
      <Route
        path='/'
        element={
          <AuthRoute>
            <WealthOverviewPage />
          </AuthRoute>
        }
      />
      <Route
        path='/wealth-overview'
        element={
          <AuthRoute>
            <WealthOverviewPage />
          </AuthRoute>
        }
      />
      {environment !== 'prod' && environment !== 'qa' && (
        <Route path='/login' element={<LoginPage />} />
      )}
      <Route
        path='/prospect-assessment'
        element={
          <AuthRoute>
            <ProspectAssessmentPage />
          </AuthRoute>
        }
      />
      <Route
        path='/prospect-assessment-interstitial'
        element={
          <AuthRoute>
            <ProspectAssessmentIntersititialPage />
          </AuthRoute>
        }
      />
      <Route
        path='/account-details/:paramId'
        element={
          <AuthRoute>
            <AccountDetailsPage />
          </AuthRoute>
        }
      />
      <Route
        path='/net-worth-details'
        element={
          <AuthRoute>
            <NetWorthDetailsPage />
          </AuthRoute>
        }
      />
      <Route
        path='/document-review'
        element={
          <AuthRoute>
            <DocumentReviewPage />
          </AuthRoute>
        }
      />
      <Route path='/logout' element={<LogoutPage />} />
      <Route path='/authenticating' element={<AuthenticatingPage />} />
      <Route path='*' element={<Navigate to='/wealth-overview' replace />} />
    </RRRoutes>
  );
};

export default Routes;
